
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 43 43"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.403 11.118h-18.72a1.17 1.17 0 00-1.168 1.167v7.75a1.17 1.17 0 001.167 1.167h18.721a1.17 1.17 0 001.168-1.167v-7.75c0-.642-.514-1.167-1.168-1.167z","fill":"#3677F6"}}),_c('path',{attrs:{"d":"M17.07 22.93h-4.388a1.17 1.17 0 00-1.167 1.167v6.91a1.17 1.17 0 001.167 1.166h4.389a1.17 1.17 0 001.167-1.167v-6.91a1.17 1.17 0 00-1.167-1.167z","fill":"#BFD8FB"}}),_c('path',{attrs:{"d":"M31.404 22.93h-9.98a1.17 1.17 0 00-1.167 1.167v6.91a1.17 1.17 0 001.167 1.166h9.98a1.17 1.17 0 001.167-1.167v-6.91c0-.641-.514-1.167-1.167-1.167z","fill":"#70A0FF"}})])
          )
        }
      }
    